import styled from 'styled-components';
import Button from '~components/dumbs/Button';

export const PrimaryButton = styled(Button)`
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-bottom: ${({ theme }) => theme.spacing.km1};
  }
`;
